import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { ease, hover, pressable, radius } from '../styles/GlobalStyles';
import { ArrowUpIcon } from './common/Icons';

const Button = styled(motion.button)`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 999;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: ${radius.md};
  border: 1px solid ${props => props.theme.colors.border};
  background: ${props => props.theme.colors.cardBackground};
  color: ${props => props.theme.colors.textSecondary};
  box-shadow: ${props => props.theme.shadows.medium};
  cursor: pointer;
  ${pressable}

  ${hover} {
    &:hover {
      color: ${props => props.theme.colors.text};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    right: 16px;
    bottom: 16px;
  }
`;

const ScrollToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <Button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.96 }}
          transition={{ duration: 0.16, ease: ease.out }}
          aria-label="Scroll to top"
        >
          <ArrowUpIcon size={16} />
        </Button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;
